const ArticleHero = () => {
  return (
    <div className="container mx-auto articles-hero-container">
      <div className="lg:text-center mx-6 lg:mx-0 articles-title-header">
        <h2 className="articles-title">Articles</h2>
        <span className="articles-page-subtitle">
          Choose a topic you like, make the quiz and win some points!
        </span>
      </div>
    </div>
  );
};

export default ArticleHero;
